import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("div", {
    staticClass: "text-h5"
  }, [_vm._v(" Add an image to the subregion "), _c("span", {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.regionSub.name))])])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_c("div", [_c("UploaderV2", {
    key: "uploaderAddingImage",
    ref: "uploaderAddingImage",
    staticClass: "w100p",
    attrs: {
      idInput: "uploaderAddingImage",
      url: _vm.addingImage.url,
      fileTypes: [".png", ".jpg", ".jpeg"],
      additionalHint: "Width:\u22431000px - Height:600px",
      additionalFormData: _vm.addingImageFormWithouValidNormalized,
      multiple: false,
      hideUploadButton: ""
    },
    on: {
      "click:upload": _vm.addingImageUploadSuccess,
      "upload:failed": _vm.addingImageUploadFailed,
      sync: _vm.addingImageSyncFiles
    }
  }), _c("div", {
    staticClass: "flex gap-2 mt-3"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: _vm.cancelAddingImage
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: !_vm.addingImageCanBeSubmitted || _vm.isAnyActionInProgress,
      loading: _vm.addingImage.isPending
    },
    on: {
      click: _vm.saveAddingImage
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-upload mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Upload ")], 1)], 1)], 1)])], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };